import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css';
import { DBCheckBoxComment } from '_components';

class PatientCareCenterNoteObjectiveObsFineMotorDevelopmentPeds extends React.Component {
  render() {
    return (
      <PatientCareCenterNoteSection id='obj_obs_finemotorpeds' name='Fine Motor Development' level={2} noChildPadding={true}>
        <div className={styles.form_row}>
          <div className={styles.gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFIFORESUP'
              className={styles.checkbox}
              label='Forearm supination to neutral'
              textAreaStyle={styles.formTextArea}
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFIFOREFULL'
              className={styles.checkbox}
              label='Forearm to full supination'
              textAreaStyle={styles.formTextArea}
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFIISOINDEX'
              className={styles.checkbox}
              label='Isolate index finger to point/probe'
              textAreaStyle={styles.formTextArea}
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFISTABILIZE'
              checkboxStyle={styles.checkbox_size}
              label='Stabilize object with one hand & manipulate with other'
              textAreaStyle={styles.formTextArea}
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFIISOFINGER'
              className={styles.checkbox}
              label='Isolation of fingers to show # 1-10'
              textAreaStyle={styles.formTextArea}
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFISEQOPP'
              className={styles.checkbox}
              label='Squential opposition'
              textAreaStyle={styles.formTextArea}
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFIFLEX'
              className={styles.checkbox}
              label='Flexibility'
              textAreaStyle={styles.formTextArea}
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.heading_gap}>
            <b>Grasp</b>
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFIINITGRASP'
              className={styles.checkbox}
              textAreaStyle={styles.formTextArea}
              label='Initiates reach/grasp'
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFIGROSS'
              className={styles.checkbox}
              textAreaStyle={styles.formTextArea}
              label='Gross grasp'
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFILATPINCH'
              className={styles.checkbox}
              textAreaStyle={styles.formTextArea}
              label='Lateral pinch'
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFITIPPINCH'
              textAreaStyle={styles.formTextArea}
              className={styles.checkbox}
              label='Tip to tip pinch'
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              textAreaStyle={styles.formTextArea}
              entityKeyValue={this.props.opno}
              field='OPFITRIPOD'
              className={styles.checkbox}
              label='Tripod grasp'
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFIOTHERGRASP'
              textAreaStyle={styles.formTextArea}
              className={styles.checkbox}
              label='Other'
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.heading_gap}>
            <b>Object Manipulation Skills</b>
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFIREMREPTWIST'
              className={styles.checkbox}
              textAreaStyle={styles.formTextArea}
              label='Remove replace twist off cover'
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFIOPENCONT'
              className={styles.checkbox}
              label='Opening/closing containers'
              textAreaStyle={styles.formTextArea}
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              textAreaStyle={styles.formTextArea}
              entityKeyValue={this.props.opno}
              field='OPFISHAPES'
              checkboxStyle={styles.checkbox_size}
              label='Place 3 shapes in form board. Single inset puzzle, interlocking puzzle'
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFIBEADS'
              className={styles.checkbox}
              label='String beads'
              textAreaStyle={styles.formTextArea}
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFISCISSOR'
              className={styles.checkbox}
              textAreaStyle={styles.formTextArea}
              label='Scissor use'
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPFIPENCIL'
              className={styles.checkbox}
              textAreaStyle={styles.formTextArea}
              label='Pencil/crayon use'
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.heading_gap}>
            <b>In-Hand Manipulation</b>
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPHMPLAMTOFINGER'
              className={styles.checkbox}
              textAreaStyle={styles.formTextArea}
              label='Palm to Finger Translation'
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPHMFINGERTOPALM'
              className={styles.checkbox}
              textAreaStyle={styles.formTextArea}
              label='Finger to Palm Translation'
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPHMSHIFT'
              className={styles.checkbox}
              textAreaStyle={styles.formTextArea}
              label='Shift'
            />
          </div>
        </div>

        <div className={styles.form_row}>
          <div className={styles.checkbox_gap}>
            <DBCheckBoxComment
              noteId={this.props.noteId}
              entity='PTOBJECTIVEPEDS'
              entityKeyColumn='OPNO'
              entityKeyValue={this.props.opno}
              field='OPHMROTATION'
              className={styles.checkbox}
              textAreaStyle={styles.formTextArea}
              label='Rotation'
            />
          </div>
        </div>

      </PatientCareCenterNoteSection>
    );
  }
}


function mapStateToProps(state) {
  let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
  let noteType = parseInt(noteId.split("_")[0]);
  let pk = parseInt(noteId.split("_")[1]);
  let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
    .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
      || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));

  return {
    noteId: noteId,
    opno: opno
  };
}

const connectedPatientCareCenterNoteObjectiveObsFineMotorDevelopmentPeds = connect(mapStateToProps)(PatientCareCenterNoteObjectiveObsFineMotorDevelopmentPeds);
export { connectedPatientCareCenterNoteObjectiveObsFineMotorDevelopmentPeds as PatientCareCenterNoteObjectiveObsFineMotorDevelopmentPeds };

